<form #formulari="ngForm">
    <div *ngIf="!preinscripcio.haPagatInscripcio">
        <p i18n="@@ImportInscripcio">Per tal que la preinscripció sigui efectiva cal abonar el preu de {{preinscripcio.preuInscripcioCalculat | currency:'EUR'}} establert per la UdG.</p>
        <p i18n>Un cop efectuat el pagament rebreu un correu electrònic que confirma la preinscripció.</p>
        <p i18n>Per sortir sense finalitzar la preinscripció tanqueu aquesta finestra. Podreu entrar a la vostra preinscripció més endavant i efectuar el pagament.</p>
        <p i18n>Si no podeu pagar amb targeta de crèdit, adreceu-vos a <a href="mailto:masters@udg.edu" target="_blank">masters@udg.edu</a></p>    
        <p i18n>A continuació et redirigirem al servei de pagament de la Universitat de Girona per tal que puguis realitzar el pagament de la inscripció.</p>        
    </div>
    <div *ngIf="preinscripcio.haPagatInscripcio">
        <p i18n>Ja s'ha abonat l'import de {{preinscripcio.preuInscripcioCalculat | currency:'EUR'}} establert per la UdG com a taxa d'inscripció.</p>
    </div>
    <mat-grid-list cols="4" rowHeight="80px" *ngIf="preinscripcio.potModificar">                      
        <mat-grid-tile colspan="4">
            <div class="pre-controls-right">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>                                
</form>


// WEBPACK FOOTER //
// ./src/app/pagament/pagament.component.html